import adminCoreRoutes from './admin/core.routes';
import adminProjectsRoutes from './admin/projects.routes';

const adminRoutes = [
    { path: '/admin-login', component: () => import('pages/admin/AdminLoginPage.vue') },
    { path: '/admin-login/code', component: () => import('pages/admin/AdminCodePage.vue') },
    { path: '/admin-login/redirect', component: () => import('pages/admin/AdminLoginRedirectPage.vue') },

    // Новая админка (объединенная)
    {
        name: 'admin-layout',
        path: '/jM5a-1Pq8',
        component: () => import('layouts/AdminLayout.vue'),
        children: [
            ...adminCoreRoutes,
            ...adminProjectsRoutes,
        ],
    },
];

export default adminRoutes;
